import AfterInitialSettingsNavi from '../components/organisms/navigation/AfterInitilaSettingsNavi';
import GlobalLeftBar from '../components/organisms/navigation/GlobalLeftBar';
import InitialSettingNavi from '../components/organisms/navigation/InitialSettingNavi';

const Home = () => {

  return (<div className="flex w-screen h-screen">
    <GlobalLeftBar active="home" />
    <div className="container mx-auto p-10 h-full overflow-y-auto">
      <div className='flex justify-between mb-14 mt-20 pb-10'>
        <h2 className="text-5xl">All In One Support Desk</h2>
      </div>
      <InitialSettingNavi />
      <AfterInitialSettingsNavi />
    </div>
  </div>);
}

export default Home;
